import SettingsForm from './settings-form';

export default SettingsForm;